import { render, staticRenderFns } from "./add-edit.vue?vue&type=template&id=e89e0646&scoped=true&"
import script from "./add-edit.vue?vue&type=script&lang=js&"
export * from "./add-edit.vue?vue&type=script&lang=js&"
import style0 from "./add-edit.vue?vue&type=style&index=0&id=e89e0646&prod&lang=scss&"
import style1 from "./add-edit.vue?vue&type=style&index=1&id=e89e0646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89e0646",
  null
  
)

export default component.exports